import { LegalPersonDetails } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/LegalPersonDetails/LegalPersonDetails';
import { NaturalPersonDetails } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/NaturalPersonDetails/NaturalPersonDetails';
import { isPersonLegal } from '@dealstack/shared/lib/common/business/person.ts';
import { GetPersonByIdRes } from '@dealstack/shared/lib/generated';
import { PEOPLE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useContext, useMemo } from 'react';
import { DIRECTORY_BREADCRUMBS } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/shared/directoryBreadcrumbs.tsx';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader.tsx';
import { Flex } from '@mantine/core';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';

import {
	PersonDataContext,
	usePersonData,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/hooks/usePersonData.ts';

interface Props {
	selectedEntityData?: GetPersonByIdRes;
	selectedEntityLoading?: boolean;
}

export const BasicDetails = ({ selectedEntityData, selectedEntityLoading }: Props) => {
	const tCapManage = useTranslationCapManage();
	const personDataController = usePersonData();
	const { dealId } = useContext(CapManageControllerContext);

	const personId = selectedEntityData?.id ?? '';
	const personDisplayName = selectedEntityData?.displayName ?? '';

	const breadcrumbs = useMemo(
		() =>
			DIRECTORY_BREADCRUMBS[PEOPLE_ROUTES.PERSON_DETAILS]({
				tCapManage,
				dealId,
				personId,
				personDisplayName,
			}),
		[tCapManage, dealId, personId, personDisplayName]
	);

	useBreadcrumbs(breadcrumbs);

	if (selectedEntityLoading) {
		return (
			<Flex h="100%" style={{ position: 'relative' }}>
				<InlineLoader />
			</Flex>
		);
	}

	if (!selectedEntityData) {
		return null;
	}
	return (
		<Flex direction="column" h="100%">
			<PersonDataContext.Provider value={personDataController}>
				{isPersonLegal(selectedEntityData.type) ? (
					<LegalPersonDetails />
				) : (
					<NaturalPersonDetails />
				)}
			</PersonDataContext.Provider>
		</Flex>
	);
};
